import { render } from "./wTimeTable.vue?vue&type=template&id=18a1c95e&ts=true"
import script from "./wTimeTable.vue?vue&type=script&lang=ts"
export * from "./wTimeTable.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__